import { Link } from "react-router-dom";
import './Home.css';

function Home() {
  return (
    <main className="homeMain">
      <div className="container">
        <img src="/iq-logo.png" alt="logo" />
        <Link className="start-btn" to="/sport/nfl">Start</Link>
      </div>
    </main>
  )
}

export default Home;